import { Component , OnDestroy, AfterViewInit, HostListener } from '@angular/core';
import {   NbSidebarService } from '@nebular/theme';
@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <!-- No windowMode: Nebular renders that as a floating window and caps it at
         layout-window-mode-max-width (1920px by default), so on any monitor wider
         than that the cabinet sat in a centred column with dead space either side
         and a gap above. A cabinet is a working surface - it takes the screen it
         is given. -->
    <nb-layout>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar"   [compactedBreakpoints]="collapse" [fixed]="menuFixed"  tag="menu-sidebar" responsive>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

    <!--  <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer> -->
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnDestroy, AfterViewInit {

  collapse =    [ ]

  constructor(private sidebarService: NbSidebarService ){}

 // panelState:string = 'collapsed'

 menuFixed: boolean = false
@HostListener('window:resize', ['$event'])
onResize(event) {
 let width = event.target.innerWidth;

 if(width <= 1300){
   this.sidebarService.compact('menu-sidebar')
   this.menuFixed = true
 }else{
  this.sidebarService.expand('menu-sidebar')
  this.menuFixed = false
  
 }
}  

    ngAfterViewInit(){
        setTimeout(()=>{
          if( window.innerWidth  <= 1300){
            this.sidebarService.compact('menu-sidebar')
            this.menuFixed = true

          }else{
          this.sidebarService.expand('menu-sidebar')
          this.menuFixed = false

        }
     })
  }

   
  ngOnDestroy(){
    
  }

   
}
